import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

const DEFAULT_TITLE = 'Pixie';

@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  constructor(
    private readonly title: Title,
    private readonly translate: TranslateService
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const titleKey = this.buildTitle(routerState);
    if (titleKey) {
      // Check if it's a translation key (starts with 'app.page_titles.')
      if (titleKey.startsWith('app.page_titles.')) {
        const translatedTitle = this.translate.instant(titleKey);
        this.title.setTitle(`${translatedTitle} | ${DEFAULT_TITLE}`);
      } else {
        // Fallback for hardcoded titles
        this.title.setTitle(`${titleKey} | ${DEFAULT_TITLE}`);
      }
    } else {
      this.title.setTitle(DEFAULT_TITLE);
    }
  }
}
